// トップスライダーの起動 // Launch the top slider
const swiper = new Swiper(".js-top-slider", {
  loop: true,
  speed: 2000,
  autoplay: {
    delay: 2000,
  },
  effect: "fade",
  fadeEffect: {
    crossFade: true,
  },
});

const imageSwiper = new Swiper(".js-image-slider", {
  loop: true,
  slidesPerView: "auto",
  speed: 6000,
  spaceBetween: 20,
  allowTouchMove: false,
  autoplay: {
    delay: 0,
  },
});

const partnerSwiper = new Swiper(".js-top-partner-slider", {
  loop: true,
  slidesPerView: "auto",
  speed: 6000,
  spaceBetween: 20,
  allowTouchMove: false,
  autoplay: {
    delay: 0,
  },
});

// トップ物件スライダー
const propertiesSlider = new Swiper(".js-top-properties-slider", {
  loop: true,
  slidesPerView: 'auto',
  spaceBetween: 24,
  speed: 600,
  grabCursor: true,
  centeredSlides: true,
  pagination: {
    el: ".c-propertiesSlider__controls-dot",
    clickable: true,
  },
  navigation: {
    nextEl: ".c-propertiesSlider__controls-arrow--next",
    prevEl: ".c-propertiesSlider__controls-arrow--prev",
  },
  breakpoints: {
    769: {
      slidesPerView: 'auto',
      spaceBetween: 24,
    },
  },
});
